 
export enum MessageParseState {
    Unparsed = 0,
    Parsed = 1,
    Failed = 2,
    Ignore = 3,
}
// src/ws/wsTypes.ts
export type WSKind = "request" | "response" | "event";
export interface WireMessage {
  message_id: number;
  chat_id: number;
  sender_id: number;
  date: number;
  text: string;
  is_outgoing: boolean;
  chat_title: string;
  is_group: number;
  parse_state: MessageParseState;
  peer: string;
}
export type WSChannel =
  | "telegram"
  | "notify"
  | "system"
  | "log"
  | string; // cho future channel mới

export interface WSError {
  code: string;
  message: string;
}

export interface WSMessage<T = any> {
  kind: WSKind;
  channel: WSChannel;
  action: string;
  requestId?: string;
  timestamp?: number;
  data?: T;
  error?: WSError | null;
}
export function isWSMessage(obj: any): obj is WSMessage {
  if (!obj || typeof obj !== "object") return false;

  // kind
  if (!["request", "response", "event"].includes(obj.kind)) return false;

  // channel
  if (!["telegram", "notify", "system", "log"].includes(obj.channel)) return false;

  // action bắt buộc phải có
  if (typeof obj.action !== "string") return false;

  return true;
}